// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BXMp0v63FwnzDto3m1By {
  width: 100%;
  height: 460px;
}

.BXMp0v63FwnzDto3m1By inpost-geowidget {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.O5whs9C5LHuaQmhKgbFH {
  border: 1px dashed var(--border-color, #cfcfcf);
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  color: var(--c-muted);
}
`, "",{"version":3,"sources":["webpack://./src/server/public/sites/client/gallery/components/choosePayment/inpostGeowidget.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":[".mount {\r\n  width: 100%;\r\n  height: 460px;\r\n}\r\n\r\n.mount inpost-geowidget {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.placeholder {\r\n  border: 1px dashed var(--border-color, #cfcfcf);\r\n  border-radius: 12px;\r\n  padding: 1rem;\r\n  text-align: center;\r\n  color: var(--c-muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var mount = `BXMp0v63FwnzDto3m1By`;
export var placeholder = `O5whs9C5LHuaQmhKgbFH`;
export default ___CSS_LOADER_EXPORT___;
